<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
                    <p class="text-h4 text--primary">
                        <TextHeading :level=3>Pomoc - wydatki niekwalifikowalne po kontroli</TextHeading>
                    </p>
                    <div class="text-body-1 text--primary">
                      Realizacja projektu niesie za sobą ryzyko utraty części dofinansowania z uwagi na uznanie w trakcie kontroli wydatków za niekwalifikowalne. Nie zawsze takie decyzje mają swoje uzasadnienie a często też wysokość nakładanych korekt finansowych jest nieadekwatna do stwierdzonej nieprawidłowości. Jeżeli w Państwa Projekcie miało miejsce stwierdzenie wydatków niekwalifikowalnych lub tez nałożenie korekty finansowej, nasi specjaliści ocenią czy i w jaki sposób można zagrożone dofinansowanie uratować. Jakiekolwiek wynagrodzenie wystąpi tylko i wyłącznie, gdy odzyskamy należne Państwu środki – rozliczamy się wyłącznie w formie success fee.  O naszym doświadczeniu i możliwościach merytorycznych niech świadczą przeprowadzone kontrole oraz zrealizowane projekty - wykaz niektórych z nich znajduje się <router-link class="nav-link" to="/our_projects">tu</router-link>
                    </div>
                    <non-eligible-expenditure-form />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  import NonEligibleExpenditureForm from "@/modules/forms/NonEligibleExpenditureForm";
  export default {
  
    components: {TextHeading, NonEligibleExpenditureForm}
  }
  </script>